import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'config/hooks';
import {
    doGetInvoicesConfig,
    doUpdateInvoiceConfigGeneralSettings,
    doUpdateInvoiceConfigInvoiceTemplate,
    doUpdateInvoiceConfigEmailTemplate,
} from 'store/invoice-config/actions';
import {
    UpdateInvoiceConfigGeneralSettingsPayload,
    UpdateInvoiceConfigInvoiceTemplatePayload,
    UpdateInvoiceConfigEmailTempaltePayload,
} from 'store/invoice-config/types';

const useInvoicesConfig = () => {
    const dispatch = useAppDispatch();

    const config = useAppSelector((state) => state.invoicesConfig.config);
    const isLoading = useAppSelector((state) => state.invoicesConfig.isLoading);
    const error = useAppSelector((state) => state.invoicesConfig.error);

    const getConfig = useCallback(() => dispatch(doGetInvoicesConfig()), [dispatch]);

    const updateGeneralSettings = useCallback(
        (payload: UpdateInvoiceConfigGeneralSettingsPayload) => dispatch(doUpdateInvoiceConfigGeneralSettings(payload)),
        [dispatch]
    );
    const updateInvoiceTemplate = useCallback(
        (payload: UpdateInvoiceConfigInvoiceTemplatePayload) => dispatch(doUpdateInvoiceConfigInvoiceTemplate(payload)),
        [dispatch]
    );
    const updateEmailTemplate = useCallback(
        (payload: UpdateInvoiceConfigEmailTempaltePayload) => dispatch(doUpdateInvoiceConfigEmailTemplate(payload)),
        [dispatch]
    );

    return {
        config,
        isLoading,
        error,
        getConfig,
        updateGeneralSettings,
        updateInvoiceTemplate,
        updateEmailTemplate,
    };
};

export default useInvoicesConfig;
